import React from 'react';
import { Panel, PanelTheme, PanelBorderRadius } from '@apply/components';
import { Button, ButtonTheme } from '@apply/components';
import { Signature } from './Signature';
import '../../scss/controls/_signpage.scss';

interface SignaturePageProps {
    agreementHeader?: React.ReactNode;
    agreementBody: React.ReactNode;
    firstName?: string;
    lastName?: string;
    onSubmitAgreement: () => void;
    onDeclineAgreement: () => void;
}

export const SignaturePage: React.FC<SignaturePageProps> = ({
    agreementHeader,
    agreementBody,
    onSubmitAgreement,
    onDeclineAgreement,
}) => {
    return (
        <div className='signpage'>
            <div className='header'>{agreementHeader}</div>
            <Panel
                theme={PanelTheme.White}
                borderRadius={PanelBorderRadius.Medium}
                padding={32}
            >
                {agreementBody}
                <Signature />
            </Panel>

            <div className='submit-button'>
                <div className='accept'>
                    <Button
                        id='primaryButton'
                        theme={ButtonTheme.Primary}
                        width='314px'
                        handleClick={onSubmitAgreement}
                    >
                        Accept
                    </Button>
                </div>
                <Button
                    id='declineButton'
                    theme={ButtonTheme.Decline}
                    width='314px'
                    handleClick={onDeclineAgreement}
                >
                    Decline
                </Button>
            </div>
        </div>
    );
};
